import { DocsGroup } from "./documents";

export function WorkerDocuments(data) {
    this.id = data.worker_id;
    this.name = data.name;
    this.hiringDate = data.hiring_date;
    this.positions = data.posts || [];
    this.citizenship = data.citizenship;
    this.filial = data.filial;
    this.lawStatus = data.law_status;

    const groups = data && data.docs_info.length > 0 && data.docs_info.map((group) => new DocsGroup(group));

    groups.sort((a, b) => a.sort - b.sort);
    this.docGroups = groups;

    // this.documents = {};
    // data.docs_info.forEach(gData => {
    //     let group = new DocsGroup(gData);
    //     group.documents.forEach(doc => {
    //         this.documents[doc.id] = doc;
    //     });
    // });
}

// Функция для создания объекта Document
export function createDocument(data, group) {
    return {
        id: data.id,
        name: data.name,
        status: data.status,
        date: data.date,
        hasExpireDate: data.has_expire_date,
        sort: data.sort,
        absentColor: data.absent_color || group.absentColor,
        expiredColor: data.expired_color || group.expiredColor,
        expiringColor: data.expiring_color || group.expiringColor
    };
}

// Функция для создания объекта DocsGroup
export function createDocsGroup(data) {
    const group = {
        id: data.id,
        name: data.name,
        sort: data.sort,
        absentColor: data.absent_color || "#FF0000",
        expiredColor: data.expired_color || "#FF238D",
        expiringColor: data.expiring_color || "#FFB800",
        documents: []
    };

    const documents = data && data.docs.length > 0 && data.docs.map((doc) => createDocument(doc, group));

    if (documents) {
        documents.sort((a, b) => a.sort - b.sort);
        group.documents = documents;
    }

    return group;
}

// Функция для создания объекта WorkerDocuments
export function createWorkerDocuments(data) {
    const worker = {
        id: data.worker_id,
        name: data.name,
        hiringDate: data.hiring_date,
        positions: data.posts || [],
        citizenship: data.citizenship,
        filial: data.filial,
        lawStatus: data.law_status,
        docGroups: []
    };

    const groups = data && data.docs_info.length > 0 && data.docs_info.map((group) => createDocsGroup(group));

    if (groups) {
        groups.sort((a, b) => a.sort - b.sort);
        worker.docGroups = groups;
    }

    return worker;
}
